"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3115],{

/***/ 6331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CollectionItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LibraryLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7906);



function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function CollectionItem(props) {
    var collectionSlug = props.collectionSlug, collectionName = props.collectionName, images = props.images;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/collection/".concat(collectionSlug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classNames(props.size === "small" ? "w-64 mx-3 mb-6" : "w-72 mx-6 mb-12", "hover:bg-white dark:hover:bg-gray-800 dark:bg-gray-900 hover:shadow-md group hover:border p-4 transition-all rounded-lg hover:border-gray-300 hover:shadow-gray-300 dark:hover:shadow-gray-700 dark:border-0 dark:hover:border-0 dark:hover:shadow-none dark:text-white"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-2 grid-rows-2 rounded-md overflow-hidden",
                        children: images.map(function(param) {
                            var url = param.url;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: url.replace("/sm", "/xxs"),
                                alt: collectionName
                            }, url);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-center font-medium text-gray-700 dark:text-gray-200 text-lg mt-4 group-hover:text-black dark:group-hover:text-white group-hover:underline decoration-secondary-dark underline-offset-4",
                        children: [
                            collectionName,
                            props.new ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LibraryLayout__WEBPACK_IMPORTED_MODULE_2__/* .NewLabel */ .e, {}) : null
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 3657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CollectionsPreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _CollectionItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6331);


function CollectionsPreview() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "scrollableDiv",
        className: "w-full h-full flex flex-col items-center justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Flat Circles",
                        collectionSlug: "flat-circles",
                        new: true,
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/408d869614958a5b65b1/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/433b920155f6e88b7991/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4f0ba1ea32191324d060/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/458fb1adf7f53d909e81/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Olden Vibes",
                        collectionSlug: "olden-vibes",
                        new: true,
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/46ea875703f94a097712/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4694a77a93fa598e4015/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/42ec86961eb1327fc7f3/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/44eaa5cf85dba5da1587/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Soft Blobs",
                        collectionSlug: "soft-blobs",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4ed8b6dcaf5f53e0d311/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d3cb281a2df8851ebe6/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4077887cf5f48be07a2d/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/40f888a59f8fbcbab5cb/xxs"
                            }, 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Raw Forms",
                        collectionSlug: "raw-forms",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4f68b15c5859b6cdaadb/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4e729450ba096b08fee7/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4168907bda03109b89ae/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d568a7401fa82d97aef/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Playful Strokes",
                        collectionSlug: "playful-strokes",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4f5a9e26c0309ae4f215/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/48b281b7efbe609bd5f0/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4a55a930da3504798492/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/451a9a83436d210f43e0/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Warm Endeavors",
                        collectionSlug: "warm-endeavors",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/400fa889832b5634005f/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/438fb0e059a12d2676b9/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/46bd928f73fe8dc2db39/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4369940169d03da83afd/xxs"
                            }, 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Cyan Essence",
                        collectionSlug: "cyan-essence",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4a47ba6b0f32f05b8b34/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/40aa9f4023c4d49794d7/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4463b7ab53b1e322fd9c/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4b16a6a53411cd95be69/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Stochastic Splash",
                        collectionSlug: "stochastic-splash",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/430a98f0e8a0d8a19f9a/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4c3fa5d1eecfcafca9bc/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d0daab197533da468c8/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d8885cafdaf1ef5b487/xxs"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: "small",
                        collectionName: "Geometric Grace",
                        collectionSlug: "geometric-grace",
                        images: [
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/Vw2tcnJWrvMZuLDVz-1D9wiap9kKs0BQ/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/z73tACeYUbPTMN6WzEgNJzGCgz6d_smb/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/ieT9RYdQBs2494HDkL6NvHjR7AuwH1-Y/xxs"
                            },
                            {
                                url: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/8CdDitBbxPW1gAE34R-m7E7Iz-_GPa95/xxs"
                            }, 
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemsProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2951);


var ItemsProvider = /*#__PURE__*/ function() {
    "use strict";
    function ItemsProvider(initialItems) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ItemsProvider);
        this.items = initialItems || [];
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ItemsProvider, [
        {
            key: "getItems",
            value: function getItems() {
                return this.items || [];
            }
        },
        {
            key: "setItems",
            value: function setItems(items) {
                this.items = items;
            }
        },
        {
            key: "isItemsEqual",
            value: function isItemsEqual(item1, item2) {
                return (item1 === null || item1 === void 0 ? void 0 : item1.image) && item1.image != (item2 === null || item2 === void 0 ? void 0 : item2.image) || (item1 === null || item1 === void 0 ? void 0 : item1.svg) && item1.svg != (item2 === null || item2 === void 0 ? void 0 : item2.svg);
            }
        },
        {
            key: "hasNext",
            value: function hasNext(item) {
                return this.isItemsEqual(this.items[this.items.length - 1], item);
            }
        },
        {
            key: "hasPrevious",
            value: function hasPrevious(item) {
                return this.isItemsEqual(this.items[0], item);
            }
        },
        {
            key: "next",
            value: function next(index) {
                return this.items[index + 1];
            }
        },
        {
            key: "previous",
            value: function previous(index) {
                return this.items[index - 1];
            }
        },
        {
            key: "setOnMoreNeeded",
            value: function setOnMoreNeeded(onMoreNeeded) {
                this.onMoreNeeded = onMoreNeeded;
            }
        },
        {
            key: "fireOnMoreNeeded",
            value: function fireOnMoreNeeded() {
                return this.onMoreNeeded ? this.onMoreNeeded() : Promise.resolve();
            }
        }
    ]);
    return ItemsProvider;
}();



/***/ }),

/***/ 7906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LibraryLayout; },
/* harmony export */   "e": function() { return /* binding */ NewLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _UserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9277);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(346);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3193);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6221);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7349);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7524);












function SidebarItem(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center justify-between p-2 px-3 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg text-sm active:bg-gray-100 " + (props.selected ? "bg-gray-100 font-medium text-secondary dark:bg-gray-800 dark:text-secondary-light" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: props.children
        })
    });
}
function SidebarTitleItem(props) {
    var Icon = function() {
        if (props.name === "Browse") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "w-4"
            });
        } else if (props.selected || props.section === "browse") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "w-5 -ml-0.5 -mr-0.5"
            });
        } else if (props.selected === false) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: "w-5 -ml-0.5 -mr-0.5"
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex text-base font-bold mb-4 mt-5 lg:px-12 xl:px-16 px-8 items-center " + (props.selected && !props.subsection ? "text-secondary" : "hover:text-slate-600 dark:hover:text-slate-400"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                    href: props.link,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: props.name
                    })
                })
            })
        ]
    });
}
function NewLabel() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "text-xs ml-2 p-1 px-2 rounded-lg bg-gray-100 dark:bg-black hover:no-underline no-underline font-medium text-blue-500 dark:text-blue-400",
        children: "New"
    });
}
function Sidebar(props) {
    var divRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var scrollToElement = function() {
        var ref;
        (ref = divRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "instant",
            block: "nearest",
            inline: "start"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(scrollToElement, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sticky top-0 bg-white dark:bg-gray-900 h-[calc(100vh-100px)] dark:text-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pt-8 flex-col h-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: ([
                        "collections",
                        "browse"
                    ].includes(props.section) ? "h-[75%] pb-16" : "") + " flex-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SidebarTitleItem, {
                            selected: props.section === "collections",
                            section: props.section,
                            subsection: props.subsection,
                            name: "Illustration Sets",
                            link: "/collection"
                        }),
                        props.collections && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-gray-700 dark:text-gray-300 h-full overflow-y-scroll px-8 xl:px-16 faded",
                            children: Object.entries(props.collections).map(function(param, i) {
                                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param, 2), slug = _param[0], name = _param[1];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "last:pb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                        href: "/collection/".concat(slug),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                ref: props.subsection === name ? divRef : null,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SidebarItem, {
                                                    selected: props.subsection === name,
                                                    children: [
                                                        name,
                                                        i < 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewLabel, {})
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                }, "/collection/" + slug);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (props.section === "categories" ? "h-[75%] pb-16" : "") + " flex-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SidebarTitleItem, {
                            selected: props.section === "categories",
                            name: "Categories",
                            link: "/category"
                        }),
                        props.categories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-gray-700 dark:text-gray-300 h-full overflow-y-scroll px-8 xl:px-16 faded",
                            children: props.categories.map(function(param) {
                                var slug = param.slug, name = param.name;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "last:pb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                        href: "/category/".concat(name),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                ref: props.subsection === name ? divRef : null,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SidebarItem, {
                                                    selected: props.subsection === name,
                                                    children: lodash__WEBPACK_IMPORTED_MODULE_1___default().startCase(name)
                                                })
                                            })
                                        })
                                    }, name)
                                }, "/category/" + (slug || name));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SidebarTitleItem, {
                        name: "Browse",
                        selected: props.section === "browse",
                        subsection: props.subsection,
                        link: "/browse"
                    })
                })
            ]
        })
    });
}
function LibraryLayout(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_UserContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), user = ref.user, supabase = ref.supabase;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.initialItem || null), selectedItem = ref1[0], setSelectedItem = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var imageId = router.asPath.includes("collection") ? router.asPath.split("/").slice(-1)[0] : router.asPath.slice(1);
        if (!props.initialItem && imageId && !imageId.startsWith("#") && imageId !== "[[...slug]]" && !(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.url) && imageId.includes("-")) {
        // setSelectedItem({
        //     image: imageId,
        // });
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex-1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "top-0 dark:text-white border-b border-gray-200 dark:border-gray-800 md:pb-2 dark:bg-gray-900 dark:bg-gradient-to-b dark:from-gray-900 dark:to-gray-950",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative z-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        className: "secondary w-full"
                    }, props), {
                        supabase: supabase,
                        user: user,
                        title: props.title,
                        description: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description) ? "Vector image of ".concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description, ". ").concat((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.caption) || "") : props.description ? "Free ".concat(props.subsection || props.title || "", " SVG vector images generated by AI. ").concat(props.description || "", " ").concat(props.haiku || "") : null,
                        image: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.url
                    }))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:block hidden sticky border-r bg-white border-gray-200 lg:w-[360px] dark:bg-gray-900 dark:border-gray-700",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Sidebar, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 bg-gray-100 dark:bg-gray-950 dark:text-gray-100 h-full",
                        children: props.children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props), {
                    user: user
                }))
            })
        ]
    });
}


/***/ }),

/***/ 3388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MasonryImageList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5121);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(246);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6746);
/* harmony import */ var _MasonryItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4256);
/* eslint-disable @next/next/no-img-element */ 












function MasonryImageList(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), inError = ref1[0], setInError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), hasMore = ref2[0], setHasMore = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEmptyState = ref3[0], setIsEmpty = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        props.itemsProvider.setOnMoreNeeded(function() {
            return fetchMore();
        });
    // return () => {
    //     return props.itemsProvider.onMoreNeeded = null;
    // }
    }, [
        props.itemsProvider
    ]);
    var fetchMore = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var items, ref, ref1, ref2, ref3, result, newItems, empty, prevItems, updatedItems, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isLoading) {
                            return [
                                2
                            ];
                        }
                        items = props.itemsProvider.getItems() || [];
                        if (props.limit && items.length >= props.limit) {
                            return [
                                2
                            ];
                        }
                        setIsLoading(true);
                        setIsEmpty(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("/api/list?from=".concat(items.length, "&q=").concat(props.query, "&base=").concat(props.baseUrl))
                        ];
                    case 2:
                        result = _state.sent();
                        newItems = (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.results) || [];
                        empty = !newItems.length && !items.length;
                        setIsEmpty(empty);
                        prevItems = items || [];
                        if (prevItems && ((ref1 = prevItems[prevItems.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.image) == ((ref2 = newItems[newItems.length - 1]) === null || ref2 === void 0 ? void 0 : ref2.image)) {
                            return [
                                2,
                                prevItems
                            ];
                        }
                        updatedItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(prevItems).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(newItems));
                        if (props.limit) {
                            updatedItems = updatedItems.slice(0, props.limit);
                        }
                        (ref3 = props.itemsProvider) === null || ref3 === void 0 ? void 0 : ref3.setItems(updatedItems);
                        if (!newItems.length) {
                            setHasMore(false);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        console.error(err);
                        setInError(true);
                        setHasMore(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchMoreThrottled = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.throttle)(fetchMore, 1000);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        // console.log("query changed", props.query, props.initialQuery, props.initialImages, props.limit, hasMore);
        if (props.query === props.initialQuery) {
            // console.log("query is the same", props.query, props.initialQuery)
            if (!props.canLoadMore) {
                setHasMore(false);
            }
            return;
        }
        setInError(false);
        setHasMore(!props.limit && ((0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(props.initialImages) || props.query && props.query !== props.initialQuery || props.canLoadMore !== false));
        ;
        setIsLoading(false);
        (ref = props.itemsProvider) === null || ref === void 0 ? void 0 : ref.setItems([]);
        setIsEmpty(false);
    }, [
        props.query
    ]);
    if (isEmptyState) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col my-12 items-center justify-center h-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-2xl font-bold text-gray-500",
                children: "No results found"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3___default()), {
        loadMore: fetchMoreThrottled,
        hasMore: hasMore,
        initialLoad: Boolean(props.limit || (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(props.initialImages) || props.query !== props.initialQuery),
        threshold: 20,
        loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {
            className: "my-8"
        }, "spinner"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "scrollableDiv",
            className: (props.align === "left" ? "items-center justify-center sm:items-start sm:justify-start" : "items-center justify-center") + " w-full h-full flex flex-wrap group",
            children: props.itemsProvider.getItems().map(function(item, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MasonryItem__WEBPACK_IMPORTED_MODULE_5__/* .MasonryItem */ .a, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                    small: props.align === "left",
                    size: props.itemSize,
                    baseUrl: props.baseUrl,
                    className: props.itemClassName
                }, item), {
                    onItemClick: function() {
                        var ref;
                        return (ref = props.onItemClick) === null || ref === void 0 ? void 0 : ref.call(props, item, i);
                    }
                }), props.query + i);
            })
        })
    });
}


/***/ }),

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function SearchBar(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.initialValue || ""), inputValue = ref[0], setInputValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!inputValue) {
            var ref;
            (ref = props.onSetQuery) === null || ref === void 0 ? void 0 : ref.call(props, "");
        }
    }, [
        inputValue,
        props
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        className: "flex-1",
        onSubmit: function(evt) {
            var ref;
            (ref = props.onSetQuery) === null || ref === void 0 ? void 0 : ref.call(props, inputValue);
            evt.preventDefault();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "mb-2 text-sm font-medium text-gray-900 sr-only",
                children: "Search"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            "aria-hidden": "true",
                            className: "w-5 h-5 text-gray-500",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "search",
                        autoComplete: "off",
                        id: "default-search",
                        defaultValue: props.initialValue,
                        className: "block p-4 pl-10 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-900 rounded-md border border-gray-300 dark:border-gray-700 outline-none dark:text-gray-100",
                        placeholder: "Search for an image",
                        required: true,
                        onChange: function(evt) {
                            return setInputValue(evt.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "submit",
                        className: "text-white absolute right-2.5 bottom-2.5 from-secondary-dark to-secondary hover:from-secondary-darkest hover:to-secondary-dark bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2",
                        children: "Search"
                    })
                ]
            })
        ]
    });
}


/***/ })

}]);